<template>
</template>


<script>

export default {
    beforeCreate: function () {
        window.location.href = 'https://shop449305549.taobao.com/?spm=pc_detail.29232929/evo365560b447259.shop_block.dshopinfo.29977dd6Tf4YmR';
    }
}
</script>


// WEBPACK FOOTER //
// src/components/ZhuoMuNiao/Index.vue